import './styles.css';
import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import {
  type ReportSeverity,
  type ReportSeverityDescriptions,
  reportSeverities,
} from '@ipfabric/utils';
import classNames from 'classnames';
import type { FC, ReactNode } from 'react';

export interface SeverityCountsProps {
  className?: string;
  counts: Partial<Record<ReportSeverity, ReactNode>>;
  descriptions?: Partial<ReportSeverityDescriptions>;
}

export const SeverityCounts: FC<SeverityCountsProps> = (props) => (
  <div className={classNames('severity-counts', props.className)}>
    {reportSeverities.map(
      (severity) =>
        props.counts[severity] !== undefined && (
          <div
            className={classNames(
              'severity-counts__severity',
              `severity-counts__severity--${severity}`,
            )}
            key={severity}
          >
            <Tooltip content={props.descriptions?.[severity] ?? undefined}>
              <span>{props.counts[severity]}</span>
            </Tooltip>
          </div>
        ),
    )}
  </div>
);
